import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useIntl } from 'react-intl'
import useInputs from '../../../utils/hooks/useInputs.js'
import CenterService from '../../../services/centers/center.service.js'
import CenterServicesForm from './form/CenterServicesForm.tsx'
import { urlBack } from './utils/center.utils.ts'
import CenterSection from './common/CenterSection.tsx'
import AppButton from '../../../component/common/AppButton.tsx'
import AppToolbar from '../../../component/layout/AppToolbar.tsx'

const CenterServices = () => {
  const { formatMessage: msg } = useIntl()

  const { id } = useParams()
  const { inputs, onChangeInputs, updateInputs } = useInputs()
  const {
    inputs: inputsService,
    onChangeInputs: onChangeInputsService,
    updateInputs: updateInputsService,
  } = useInputs()

  const navigate = useNavigate()

  useEffect(() => {
    // console.log("CenterData", id)
    getCenterData()
    getCenterServices()
  }, [])

  const getCenterData = async () => {
    const response = await CenterService.getById(id)
    if (response) {
      updateInputs(response.resp)
    }
  }

  const getCenterServices = async () => {
    if (id && id !== 'undefined') {
      const response = await CenterService.services.getById(id)
      if (response) {
        updateInputsService(response.resp)
      }
    }
  }

  const handleSave = async () => {
    const data = {
      ...inputsService,
    }

    const response =
      id && id !== 'undefined'
        ? await CenterService.services.update({ id, body: data })
        : await CenterService.services.create(data)
    if (response) {
      updateInputsService(response?.resp)
      navigate(urlBack(inputs?.centerType))
    }
  }

  const data = (
    <CenterServicesForm
      centerId={id}
      activityType={inputs?.basicData?.activityType}
      handleSave={handleSave}
      inputs={inputsService}
      onChangeInputs={onChangeInputsService}
      updateInputs={updateInputsService}
    />
  )

  return (
    <CenterSection
      toolbar={
        <AppToolbar
          rightSection={[
            <AppButton
              preset="back"
              onClick={() => navigate(urlBack(inputs?.centerType))}
            />,
            <AppButton preset="save" onClick={handleSave} />,
          ]}
        />
      }
    >
      {data}
    </CenterSection>
  )
}

export default CenterServices
